<h3 class="ml-2">{{ "NAV_STAFF_MANAGEMENT" | translate }}</h3>

<div class="row">
  <div class="col-12">
    <div class="row mb-2 ml-1 align-items-baseline">
      <span class="fa-solid fa-user fa-fw staffSuperUser ml-2"></span>
      <small> = {{ "STAFF_CUSTOMER_ADMIN" | translate }}</small>

      <span class="fa-light fa-user fa-fw staffMainUser ml-2"></span>
      <small> = {{ "STAFF_MAIN_USER" | translate }}</small>

      <span class="fa-light fa-user fa-fw staffUser ml-2"></span>
      <small> = {{ "STAFF_USER" | translate }}</small>

      <span class="fa-light fa-user fa-fw ml-2"></span>
      <small> = {{ "STAFF_READONLY" | translate }}</small>

      @if (featureEnabled('EveronMobileApp')) {
        <span class="fa-light fa-user fa-fw ml-2 staffEMA"></span>
      }
      @if (featureEnabled('EveronMobileApp')) {
        <small> = {{ "EveronMobileApp" | translate }}</small>
      }

      @if (featureEnabled('AnnaPerenna') || featureEnabled('OnOn')) {
        <span class="fa-light fa-user fa-fw ml-2 staffONONMU"></span>
      }
      @if (featureEnabled('AnnaPerenna') || featureEnabled('OnOn')) {
        <small> = {{ "STAFF_ONON_MAIN_USER" | translate }}</small>
      }
    </div>

    <div class="row mt-3 d-flex justify-content-between">
      @if (user.roleLevel >= 50) {
        <div class="ml-4">
          <button class="btn btn-primary" (click)="addNewStaff()">
            <span class="fa-light fw fa-plus"></span>
            {{ "ADD_NEW_STAFF" | translate }}
          </button>
          @if (!filterON) {
            <button class="btn btn-light ml-2" (click)="showLocationsWithoutStaff = !showLocationsWithoutStaff">
              {{ (showLocationsWithoutStaff ? "HIDE_LOCATIONS_WITHOUT_STAFF" : "SHOW_LOCATIONS_WITHOUT_STAFF") | translate }}
            </button>
          }
        </div>
      }

      <div class="d-flex flex-row justify-content-end">
        <mat-form-field class="staffFilterInput" appearance="outline">
          <input
            matInput
            id="staffSearchInput"
            placeholder="{{ 'SEARCH_BY_NAME_ID_EMAIL_GSM' | translate }}... "
            #staffSearchInput
            (keydown.enter)="onEnterKeydown($event)"
            />

            @if (filterON) {
              <button
                class="staffClearFilterBtn mr-2"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="clearFilter()"
                matTooltip="{{ 'CLEAR_FILTER' | translate }}"
                matTooltipPosition="above"
                matTooltipClass="clearFilterTooltipStyle"
                matTooltipShowDelay="50"
                matTooltipHideDelay="150"
                >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>

          <button class="btn btn-primary ml-2 mr-4" style="width: 200px" #staffSearchButton>
            <span class="fa-light fa-magnifying-glass"></span>
            {{ "SEARCH" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3 p-2">
    <div [ngClass]="{ 'd-none d-xl-block col-xl-6': selectedStaff || selectedLocation, 'col-lg-12': true }">
      @if (!staffExists(staffLocationList) && filterON) {
        <mat-card>
          {{ "NO_MATCHES" | translate }}
        </mat-card>
      }

      @for (location of staffLocationList; track location; let i = $index) {
        @if (showLocationsWithoutStaff || location.staff) {
          <div
            class="card"
            [ngClass]="{ 'ml-4': !isCustomerLocation(location) && showCustomerLocation() }"
            >
            <div class="card-header cursorPointerHover" (click)="location.collapseState = !location.collapseState">
              <h5>
                @if (isCustomerLocation(location)) {
                  <span class="fa-fw mr-2" [ngClass]="location.collapseState ? 'fa-light fa-user' : 'fa-solid fa-user'"></span>
                }
                @if (!isCustomerLocation(location)) {
                  <span class="fa-fw mr-2" [ngClass]="location.collapseState ? 'fa-light fa-house' : 'fa-solid fa-house'"></span>
                }
                {{ location.name }}
                @if (location.networkFailureState) {
                  <span class="ml-3 text-danger locationNetworkFailureText">
                    <span class="fa-light fa-fw fa-wifi-slash"></span>
                    {{ "NETWORK_FAILURE" | translate }}
                  </span>
                }
                <span
                  matTooltip="{{ 'TOOLTIP_EDIT_LOCATION' | translate }}"
                  [ngClass]="user.roleLevel >= 50 ? 'fa-light fa-pen-to-square' : 'fa-light fa-info'"
                  class="float-right mr-2 cursorPointerHover"
                  (click)="editLocation(location); $event.stopPropagation()"
                ></span>
              </h5>
              <small>{{ "NR_OF_STAFF" | translate }}: {{ location.staff ? location.staff.length : 0 }}</small>
            </div>
            <div [hidden]="!location.collapseState" class="card-body-white">
              <table class="table table-borderless table-hover table-responsive" matSort (matSortChange)="sortData($event, i)">
                <thead>
                  <tr class="border-bottom">
                    <th mat-sort-header="usingLevel" style="width: 1%"></th>
                    <th mat-sort-header="id">ID</th>
                    <th mat-sort-header="username">
                      {{ "USERNAME" | translate }}
                    </th>
                    <th mat-sort-header="fullName" style="width: 20%">
                      {{ "NAME" | translate }}
                    </th>
                    @if (featureEnabled('EveronMobileApp')) {
                      <th mat-sort-header="emaOnline" style="width: 1%">
                        {{ "EMA" | translate }}
                        <span matTooltip="{{ 'TOOLTIP_EMA' | translate }}" class="fa fa-fw fa-info-circle"></span>
                      </th>
                    }
                    <th mat-sort-header="gsmNumber">
                      {{ "GSM_NUMBER" | translate }}
                    </th>
                    <th mat-sort-header="email">
                      {{ "EMAIL" | translate }}
                    </th>
                    @if (!selectedStaff && !selectedLocation) {
                      <th mat-sort-header="lastLoginTime">
                        {{ "LAST_LOGIN" | translate }}
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (staff of location.staff; track staff) {
                    <tr
                      matTooltip="{{ 'TOOLTIP_EDIT_STAFF' | translate }}"
                      class="cursorPointer"
                      [ngClass]="{ lockedStaff: staff.locked }"
                      (click)="editStaff(staff)"
                      >
                      <td><span class="fa-fw fa-lg" [ngClass]="getStaffIcon(staff)"></span></td>
                      <td [innerHTML]="staff.id | highlight : filterCriteria"></td>
                      <td [innerHTML]="staff.username | highlight : filterCriteria"></td>
                      <td class="staffNameCell" [innerHTML]="staff.fullName | highlight : filterCriteria"></td>
                      @if (featureEnabled('EveronMobileApp')) {
                        <td>
                          @if (!staff.emaOnline) {
                            <i class="fa-regular fa-circle mr-2 emaOffline"></i>
                          }
                          @if (staff.emaOnline) {
                            <i class="fa-solid fa-circle-check mr-2 emaOnline"></i>
                          }
                        </td>
                      }
                      <td [innerHTML]="staff.gsmNumber | highlight : filterCriteria"></td>
                      <td class="staffEmailCell" [innerHTML]="staff.email | highlight : filterCriteria"></td>
                      @if (!selectedStaff && !selectedLocation) {
                        <td style="white-space: nowrap">
                          @if (staff.lastLoginTime) {
                            <span>{{ staff.lastLoginTime | date:'dd.MM.yyyy HH:mm' }}</span>
                            @if (staff.lastLoginService === 'EMA') {
                              <span class="fa-light fa-fw fa-mobile ml-1" matTooltip="EMA"></span>
                            }
                            @if (staff.lastLoginService === 'Portal') {
                              <span class="fa-light fa-fw fa-desktop ml-1" matTooltip="Portal"></span>
                            }
                          } @else {
                            <span class="text-muted">{{ "NEVER" | translate }}</span>
                          }
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      }

      @if (!staffList) {
        <div>
          <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg"/>
        </div>
      }
    </div>

    <div class="col-xl-6 col-lg-12">
      @if (loadingStaffInformation) {
        <div>
          <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg"/>
        </div>
      }

      @if (selectedStaff && !loadingStaffInformation) {
        <staff-info
          [staff]="selectedStaff"
          [locations]="locationList"
          (closeStaffCardEvent)="editStaff($event)"
          (staffUpdateEvent)="staffUpdated($event)"
          (staffInsertEvent)="staffInserted($event)"
          (staffDeleteEvent)="staffDeleted($event)"
        ></staff-info>
      }

      @if (selectedLocation && !selectedStaff) {
        <location-info
          [location]="selectedLocation"
          (locationDeletedEvent)="locationDeleted($event)"
          (locationUpdateEvent)="locationUpdated($event)"
          (closeLocationCardEvent)="closeLocation($event)"
        ></location-info>
      }
    </div>
  </div>
